module.exports = __webpack_public_path__ + "assets/images/shop9.f695bd35.jpg";